<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});
</script>

<template>
  <ul class="list-outside list-disc ml-32">
    <slot />
  </ul>
</template>
